import errorManager from '@/rollbar.js';

const gdpr_request = function (gdpr_user, gdpr_from, gdpr_to) {
  Loader.show();

  $.ajax({
    url: '/it/reports/generate_cartella_gdpr.json',
    type: 'POST',
    data: { user: gdpr_user, from: gdpr_from, to: gdpr_to },
    dataType: 'json',
    success: function (result) {
      Loader.hide();
      Utils.appendToFlash('success', i18nJS.gdpr_notice_saved);
    },
    error: function (error) {
      console.error(error);
      Loader.hide();
      Utils.appendToFlash('error', i18nJS.gdpr_notice_error);
    },
  });
};

const setObserver = () => {
  $('#gdpr_button_all').on('click', function () {
    Utils.clearNotice();
    gdpr_request('', '', '');
  });

  $('#gdpr_button').on('click', function () {
    Utils.clearNotice();
    let gdpr_user = $('#gdpr_user').val();
    let gdpr_from = $('#gdpr_from').val();
    let gdpr_to = $('#gdpr_to').val();
    if (gdpr_user == null && gdpr_from == '' && gdpr_to == '') {
      Utils.appendToFlash('error', i18nJS.gdpr_filter_none_selected);
    } else if (gdpr_from != '' && gdpr_to == '') {
      Utils.appendToFlash('error', i18nJS.gdpr_filter_both_date);
    } else if (gdpr_from == '' && gdpr_to != '') {
      Utils.appendToFlash('error', i18nJS.gdpr_filter_both_date);
    } else {
      gdpr_request(gdpr_user, gdpr_from, gdpr_to);
    }
  });
};

const init = () => {
  try {
    setObserver();
  } catch (e) {
    errorManager(e);
  }
};

window.GdprReports = {
  init: init,
};
